import React from 'react'
import PropTypes from 'prop-types'
import { trackAnalyticsEvent } from 'analytics'
import styles from './PhoneNumber.module.scss'

const PhoneNumber = (props) => {
  const {
    number,
    showLink,
    trackEventName,
    showIcon,
    phoneType
  } = props

  const component = showLink ? (
    <a
      data-test-id="phoneNumberMobile"
      href={`tel:${number}`}
      onClick={() => trackAnalyticsEvent(trackEventName)}>
      {showIcon &&
        <img data-test-id="phoneIcon" className={styles.icon} alt="phone" src="/images/phone.png" />
      }
      {number} {phoneType && <i>&nbsp;{phoneType}</i>}
    </a>
  ) : (
    <span data-test-id="phoneNumberDesktop">
      {showIcon &&
        <img data-test-id="phoneIcon" className={styles.icon} alt="phone" src="/images/phone.png" />
      }
      <span>{number}
        {phoneType && <i>&nbsp;{phoneType}</i>}
      </span>
    </span>
  )

  return component
}

PhoneNumber.propTypes = {
  number: PropTypes.string.isRequired,
  showLink: PropTypes.bool.isRequired,
  trackEventName: PropTypes.string,
  showIcon: PropTypes.bool,
  phoneType: PropTypes.string
}

PhoneNumber.defaultProps = {
  trackEventName: '',
  showIcon: false,
  phoneType: ''
}

export default PhoneNumber



// WEBPACK FOOTER //
// ./src/components/Client/PhoneNumber/PhoneNumber.jsx